import Http from '@/services/Http';

const onboardings = new Http('onboardings', {}, 'bff');

onboardings.getOnboardings = () => onboardings.get();

onboardings.updateOnboardings = (params) => onboardings.put(params);

const envelopeSettings = new Http('envelope-settings', {}, 'bff');

envelopeSettings.getSettings = () => {
  envelopeSettings.supressDefault = true;
  return envelopeSettings.get().finally(() => {
    envelopeSettings.supressDefault = false;
  });
};

envelopeSettings.updateSettings = (data) => {
  envelopeSettings.supressDefault = true;
  return envelopeSettings.put(null, data, '').finally(() => {
    envelopeSettings.supressDefault = false;
  });
};

export default onboardings;
export { envelopeSettings };
